<template>
  <div>
    <div class="auth-area" v-if="showForm" >
      <div class="text-center" style="padding-bottom: 20px;">
        <img src="../../assets/logo.png" alt="" width="300px"/>
      </div>
      <el-form>
        <el-form-item label="Kullanıcı Adı">
          <el-input placeholder="Kullanıcı adınızı yazınız" id="usernameInput" v-model="form.username"
                    @keyup.native.enter="loginAction"></el-input>
        </el-form-item>
        <el-form-item label="Şifreniz">
          <el-input type="password" placeholder="Şifrenizi yazınız" v-model="form.password"
                    @keyup.native.enter="loginAction"  ref="pw" id="passwordInput"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="loginAction" type="success" :loading="$root.loader"><i class="fa fa-check"></i>
            Giriş yap
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="old-accounts auth-area" v-if="!showForm">
      <div class="text-center" style="padding-bottom: 20px;">
        <img src="../../assets/logo.png" alt="" width="300px"/>
      </div>
      <ul class="old-accounts-ul">
        <li v-for="account in oldAccounts">
          <el-button size="big" plain="" style="width: 100%;" @click.prevent="handleLoginButton(account.username)"><i class="fa fa-lock"></i> {{account.username}} olarak giriş yap</el-button>
        </li>
        <li>
          <hr/>
        </li>
        <li>
          <el-button size="big" type="success" plain="" style="width: 100%;" @click="handleLoginButton('')">Başka bir kullanıcı ile giriş yap</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import Auth from '../../auth';

  export default {
    name: 'Login',
    data() {
      return {
        form: {
          username: null,
          password: null
        },
        oldAccounts:[],
        showForm:true
      }
    },
    created() {
      this.$root.layout.ready = false;
      this.oldAccounts = JSON.parse(localStorage.getItem('oas'));
      if(Object.keys(this.oldAccounts).length > 0 ){
        this.showForm = false;
      }
    },
    methods: {
      loginAction() {
        if (!this.form.username || !this.form.username) {
          this.$notify({
            title: 'Giriş Hatası',
            message: 'Lütfen tüm sahaları doldurunuz',
            type: 'error'
          });
          return false;
        }
        Auth.login(this, {username: this.form.username, password: this.form.password});
      },
      handleLoginButton(username){
        setTimeout(() => {
          this.$refs.pw.focus();
        }, 100);
        this.form.username = username;
        this.showForm = true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue